exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/empty.png"));

// Module
exports.push([module.id, ".nothing_tip[data-v-02ac0411]{min-height:436px;-webkit-justify-content:center;justify-content:center;-webkit-align-items:center;align-items:center}.nothing_tip .no[data-v-02ac0411]{height:115px;width:120px;background:url(" + ___CSS_LOADER_URL___0___ + ") no-repeat 50%/auto 115px}", ""]);

